import { LoungeWithUsers } from "src/features/lounge/types";
import { ParticipantCard } from "./participant-card";
import { FiUser as Users } from "react-icons/fi";

export const LoungeParticipants: React.FC<{ data: LoungeWithUsers }> = ({ data }) => {
  const joinersArr = Object.values(data.joiners ?? {}).filter(Boolean);
  const selectedCount = joinersArr.filter((j) => j?.isSelected).length;

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
          <Users className="w-5 h-5 text-blue-600" />
          Participants
        </h3>
        <div className="flex items-center gap-3">
          <div className="text-sm text-gray-600 bg-blue-50 px-3 py-1.5 rounded-full border border-blue-200">
            <span className="font-bold text-blue-600">{selectedCount}</span>
            <span className="mx-1">/</span>
            <span className="font-medium">{joinersArr.length}</span>
            <span className="ml-1">selected</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <ParticipantCard title="Initiator" user={data.initiator} isInitiator={true} />

        {joinersArr.map((j, index) => (
          <div key={j?.id} style={{ animationDelay: `${(index + 1) * 100}ms` }}>
            <ParticipantCard title="Joiner" user={j} />
          </div>
        ))}
      </div>
    </section>
  );
};
